import createAxios from 'config/axios'

const getWithdrawalMessage = () =>
  createAxios.get('/transfer-financial/withdrawals/notifications')

export default getWithdrawalMessage
